import React, { ReactElement, ChangeEvent } from "react"
import styled from "styled-components"

interface CheckboxV2Props {
  label: string
  sublabel?: string
  checked: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  value?: string | number
  name?: string
  disabled?: boolean
  id?: string
  className?: string
}

// Remove width: 100% from container, and prevent shrinking of checkbox
const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
`

const CheckboxWrapper = styled.span`
  position: relative;
  display: flex;
  align-items: center;
`

const StyledCheckbox = styled.input.attrs({ type: "checkbox" })`
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #c7c7c7;
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
  outline: none;
  vertical-align: middle;
  background: #fff;
  flex-shrink: 0;

  &:checked + span {
    /* Show the checkmark when checked */
    opacity: 1;
  }
`

const Checkmark = styled.span`
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.1s;
  /* SVG checkmark styling */
  svg {
    display: block;
    width: 12px;
    height: 12px;
    color: #4caf50;
  }
`

const LabelText = styled.span`
  color: #000000;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const SublabelText = styled.span`
  color: #c1c1c1;
  font-size: 10px;
  margin-top: 2px;
`

export const CheckboxV2 = ({
  label,
  sublabel,
  checked,
  onChange,
  value,
  name,
  disabled,
  id,
  className,
}: CheckboxV2Props): ReactElement => {
  return (
    <CheckboxContainer className={className}>
      <CheckboxWrapper>
        <StyledCheckbox checked={checked} onChange={onChange} value={value} name={name} disabled={disabled} id={id} />
        <Checkmark>
          <svg viewBox="0 0 16 16" fill="none">
            <polyline
              points="4,9 7,12 12,5"
              stroke="#4caf50"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Checkmark>
      </CheckboxWrapper>
      <LabelText>
        {label}
        {sublabel && <SublabelText>{sublabel}</SublabelText>}
      </LabelText>
    </CheckboxContainer>
  )
}
